const brandConfig = (function() {
  const brandData = window.ShopifyBrandData || {};
  return {
    name:           brandData.shop_name,
    domain:         brandData.domain,
    brand_name:     brandData.shop_name,
    primaryColor:   brandData.primaryColor,
    secondaryColor: brandData.secondaryColor,
    accentColor:    brandData.accentColor,
    fontFamily:     brandData.fontFamily,
    logoUrl:        brandData.logo,
    embedSocialChave: brandData.embedKey,
    social: {
      instagram: brandData.social?.instagram,
      facebook:  brandData.social?.facebook,
      youtube:   brandData.social?.youtube,
      website:   "https://" + brandData.domain
    }
  };
})();

window.currentBrand = brandConfig;